import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import Header from '../../components/Header'
import Footer from '../../components/Footer'
import ListeningContent from '../../components/ListeningContent'
import ReadingContent from '../../components/ReadingContent'
import { setShareState } from '../../services/native'

import styles from './index.module.css'

export default function PreTest() {
  const { testType } = useSelector(state => state.app)

  useEffect(() => {
    setShareState(false)
  }, [])

  return (
    <div className={styles.root}>
      <Header variant='pretest' />
      {testType === 2 ? <ListeningContent /> : <ReadingContent />}
      <Footer variant='pretest' />
    </div>
  )
}
